module.exports = __webpack_public_path__ + "img/cn4.08d9c6c.png";